import { render, staticRenderFns } from "./TypeField.vue?vue&type=template&id=014aafaa&scoped=true"
import script from "./TypeField.vue?vue&type=script&lang=js"
export * from "./TypeField.vue?vue&type=script&lang=js"
import style0 from "./TypeField.vue?vue&type=style&index=0&id=014aafaa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014aafaa",
  null
  
)

export default component.exports